import { GET_OFFER, GET_OFFER_BY_ID } from "../constants/index";

export const offer = (state = { offerlist: [], offerbyid: {} }, action) => {
  switch (action.type) {
    case GET_OFFER:
      return { ...state, offerlist: action.offerlist };
    case GET_OFFER_BY_ID:
      return { ...state, offerbyid: action.offerbyid };
    default:
      return state;
  }
};
